import { ReactNode } from "react";
import { useUiContext } from "@rotorstudios/fe-ui";
import classNames from "classnames";
import "./LayoutContainer.scss";

type LayoutContainerProps = {
  customClassName?: string;
  children: ReactNode;
};

const LayoutContainer = ({ customClassName = "", children }: LayoutContainerProps) => {
  const { projectClass } = useUiContext();

  const getClassName = () =>
    classNames(`${projectClass}_LayoutContainer`, customClassName);

  return <div className={getClassName()}>{children}</div>;
};

export default LayoutContainer;
